module.exports = __webpack_public_path__ + "static/turtle-creek-house18-4cd885b708ba2e98bf5bb6cc7b996c8e.jpg";